export type UserTabId = "requests" | "policy-checks" | "it-checks";

export interface UserTabDefinition {
  id: UserTabId;
  label: string;
}

export const USER_TABS: readonly UserTabDefinition[] = [
  { id: "requests", label: "Мои сайты" },
  { id: "policy-checks", label: "Проверка политики обработки ПД" },
  { id: "it-checks", label: "Проверка минцифры" },
] as const;

export const DEFAULT_USER_TAB: UserTabId = "requests";

export const isUserTabId = (value: string | null | undefined): value is UserTabId =>
  Boolean(value && USER_TABS.some((tab) => tab.id === value));

export const resolveUserTab = (value: string | null | undefined): UserTabId =>
  isUserTabId(value) ? value : DEFAULT_USER_TAB;
